<template>
  <b-modal
    id="save-to-list"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="saveToList"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Salvar na lista
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div v-if="lists.length > 0">
        <ul class="lists">
          <li
            class="mb-3"
            v-for="list in lists"
            :key="list.id"
          >
            <div
              class="default-form"
              :class="{ loading: loading === list.id }"
            >
              <label
                class="d-flex align-items-center w-100 cursor-pointer"
                :class="{ disabled: !!loading }"
                :for="list.id"
                @click.prevent="toggle(list)"
              >
                <div class="col-1 px-0">
                  <div
                    class="styled-checkbox"
                  >
                    <input
                      :id="list.id"
                      type="checkbox"
                      :checked="list.is_in_list"
                    />
                    <span></span>
                  </div>
                  <Loader
                    color="color2"
                    class="loader"
                  />
                </div>
                <div class="col-10 px-0 pl-2">
                  {{ list.name }}
                </div>
                <div class="col-1 px-0 text-center">
                  <i class="fa fa-lock" v-if="list.visibility === 'private'"></i>
                  <i class="fa fa-globe" v-if="list.visibility === 'public'"></i>
                </div>
              </label>
            </div>
          </li>
        </ul>

        <div
          v-if="createForm"
        >
          <form
            action=""
            method="POST"
            @submit.prevent="create"
          >
            <div class="form-group">
              <input
                type="text"
                class="form-control bordered-bottom w-100 text-left font-size-small"
                v-model="$v.list.name.$model"
                placeholder="Nome"
              />
            </div>
            <div class="form-group styled-select-bordered-bottom">
              <select
                class="form-control bordered-bottom w-100 text-left font-size-small"
                v-model="list.visibility"
              >
                <option value="private">Privado</option>
                <option value="public">Público</option>
              </select>
            </div>
            <div class="text-center">
              <Button
                type="submit"
                class="btn-primary btn-sm"
                :loading="creating"
                :disabled="$v.$invalid"
              >
                Salvar
              </Button>
            </div>
          </form>
        </div>
        <div
          class="text-center"
          v-else
        >
          <Button
            class="btn-outline-color2 btn-sm"
            @click="createForm = !createForm"
          >
            Criar nova lista
          </Button>
        </div>
      </div>
      <Loader
        color="color2"
        size="big"
        v-else
      />
    </template>
  </b-modal>
</template>

<script>

import ListsService from '@/modules/lists/services/lists-service'
import { parseErrorResponseToArray } from '@/utils'
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper.vue'
import Button from '@/components/common/Button/Button.vue'
import Loader from '@/components/common/Loader/Loader.vue'

export default {
  name: 'SaveToListModal',
  props: ['target', 'type'],
  components: {
    AlertWraper,
    Button,
    Loader
  },
  data () {
    return {
      lists: [],
      errors: null,
      loading: null,
      createForm: false,
      creating: false,
      list: {
        name: '',
        visibility: 'public'
      }
    }
  },
  validations () {
    return {
      list: {
        name: { required }
      }
    }
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true,
        'modal-small': true
      }
    }
  },
  methods: {
    shown () {
      this.reset()
      this.getLists()
    },
    hidden () {
      this.reset()
    },
    reset () {
      this.lists = []
      this.creating = false
      this.createForm = false
      this.loading = null
      this.errors = null
      this.loader = false
      this.list.name = ''
    },
    async getLists () {
      this.lists = []
      try {
        const lists = await ListsService.getLists({ contentType: this.type, contentId: this.target })
        this.lists = lists
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
    },
    async toggle (list) {
      this.loading = list.id
      try {
        let action = null
        if (list.is_in_list) {
          action = 'remove'
        } else {
          action = 'add'
        }
        await ListsService.toggleContentToList(list.id, action, { contentType: this.type, contentId: this.target })
        const index = this.lists.findIndex(l => l.id === list.id)
        const newList = Object.assign({}, list)
        newList.is_in_list = !newList.is_in_list
        this.lists.splice(index, 1, newList)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loading = null
    },
    async create () {
      this.creating = true
      try {
        const newList = await ListsService.postList(null, this.list)
        this.lists.push(newList)
        this.list.name = ''
        this.list.visibility = 'public'
        this.createForm = false
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.creating = false
    }
  }
}
</script>

<style lang="scss" scoped>
ul.lists {
  li {
    font-size: $font_size_small;

    .disabled {
      opacity: 0.6;
      pointer-events: none;
    }

    .styled-checkbox {
      label {
        margin-bottom: 0;
      }
    }

    .loader {
      display: none;
    }

    .loading {
      .loader {
        display: block;
      }
      .styled-checkbox {
        display: none;
      }
    }
  }
}
</style>
